/** This script was auto generated by 'TypeValidatorCreator' at 'src/infrastructure/scripts/Typescript/TypeValidator.ts' **/
import { createValidator } from '../../schema'
import type {
    MinimalInvalidOTPResponse,
    MinimalLoginResponse,
    MinimalPaginatedPermissionsResponse,
    MinimalPaginatedRoles,
    MinimalPaginatedUsers,
    MinimalPermissionIndex,
    MinimalRoleIndex,
    MinimalSessionResponse,
    MinimalUserBannedResponse,
    MinimalUserIndex,
} from './Types'

const MinimalInvalidOTPResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalInvalidOTPResponse',
    definitions: {
        MinimalInvalidOTPResponse: {
            anyOf: [
                { type: 'object', properties: { error: { type: 'string', const: 'invalid' }, msg: { type: 'string' } }, required: ['error', 'msg'] },
                {
                    type: 'object',
                    properties: {
                        error: { type: 'string', const: 'wrong OTP' },
                        triesLeft: { type: 'number' },
                        banDurationMinutes: { type: 'number' },
                        msg: { type: 'string' },
                    },
                    required: ['error', 'triesLeft', 'banDurationMinutes', 'msg'],
                },
                { $ref: '#/definitions/ReadonlyRecord%3Cstring%2Cnever%3E' },
            ],
            deprecated: true,
        },
        'ReadonlyRecord<string,never>': { type: 'object', additionalProperties: { not: {} } },
    },
}
export const isMinimalInvalidOTPResponse = createValidator<MinimalInvalidOTPResponse>(MinimalInvalidOTPResponseSchema, 'isMinimalInvalidOTPResponse')
const MinimalLoginResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalLoginResponse',
    definitions: {
        MinimalLoginResponse: {
            anyOf: [
                {
                    type: 'object',
                    properties: {
                        expiresAt: { type: 'string', description: 'ISO Format' },
                        permissions: { type: 'array', items: { $ref: '#/definitions/Permission' } },
                        token: { type: 'string' },
                    },
                    required: ['expiresAt', 'permissions', 'token'],
                },
                {
                    type: 'object',
                    properties: {
                        enforceMFAEnrollment: { type: 'boolean', const: true },
                        expiresAt: { type: 'string', description: 'ISO Format' },
                        permissions: { type: 'array', items: { $ref: '#/definitions/Permission' } },
                        token: { type: 'string' },
                    },
                    required: ['enforceMFAEnrollment', 'expiresAt', 'permissions', 'token'],
                },
                {
                    type: 'object',
                    properties: {
                        expiresAt: { type: 'string', description: 'ISO Format' },
                        needsMfa: { type: 'boolean', const: true },
                        secret: { type: 'string' },
                    },
                    required: ['expiresAt', 'needsMfa', 'secret'],
                },
            ],
            deprecated: true,
        },
        Permission: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
                operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                resource: { type: 'string' },
            },
            required: ['id', 'context', 'operation', 'resource'],
            deprecated: true,
        },
    },
}
export const isMinimalLoginResponse = createValidator<MinimalLoginResponse>(MinimalLoginResponseSchema, 'isMinimalLoginResponse')
const MinimalPaginatedPermissionsResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedPermissionsResponse',
    definitions: {
        MinimalPaginatedPermissionsResponse: {
            type: 'object',
            properties: {
                permissions: { type: 'array', items: { $ref: '#/definitions/PermissionWithUsage' } },
                pagination: { $ref: '#/definitions/Pagination' },
            },
            required: ['permissions', 'pagination'],
            deprecated: true,
        },
        PermissionWithUsage: {
            type: 'object',
            properties: {
                usage: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                            roleId: { type: 'string' },
                            roleName: { type: 'string' },
                            isRoleShared: { type: 'boolean' },
                            userId: { type: ['string', 'null'] },
                            username: { type: ['string', 'null'] },
                        },
                        required: ['operation', 'roleId', 'roleName', 'isRoleShared', 'userId', 'username'],
                    },
                },
                resource: { type: 'string' },
                context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
            },
            required: ['context', 'resource', 'usage'],
            deprecated: true,
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: { type: 'number' },
                nextPage: { type: 'number' },
                pageNumber: { type: 'number' },
                rowsPerPage: { type: 'number' },
                totalRows: { type: 'number' },
                totalRowsInPage: { type: 'number' },
            },
            required: ['totalPages', 'nextPage', 'pageNumber', 'rowsPerPage', 'totalRows', 'totalRowsInPage'],
            deprecated: true,
        },
    },
}
export const isMinimalPaginatedPermissionsResponse = createValidator<MinimalPaginatedPermissionsResponse>(
    MinimalPaginatedPermissionsResponseSchema,
    'isMinimalPaginatedPermissionsResponse'
)
const MinimalPaginatedRolesSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedRoles',
    definitions: {
        MinimalPaginatedRoles: {
            type: 'object',
            properties: { roles: { type: 'array', items: { $ref: '#/definitions/PaginatedRole' } }, pagination: { $ref: '#/definitions/Pagination' } },
            required: ['roles', 'pagination'],
            deprecated: true,
        },
        PaginatedRole: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                name: { type: 'string' },
                isshared: { type: 'boolean' },
                autogenerated: { type: 'boolean' },
                permissions: {
                    anyOf: [
                        { type: 'array', items: { $ref: '#/definitions/Permission' } },
                        {
                            type: 'array',
                            items: { $ref: '#/definitions/ReadonlyRecord%3C(%22id%22%7C%22context%22%7C%22operation%22%7C%22resource%22%7Cstring)%2Cnull%3E' },
                            minItems: 1,
                            maxItems: 1,
                        },
                    ],
                },
                users: {
                    anyOf: [
                        {
                            type: 'array',
                            items: { type: 'object', properties: { id: { type: 'string' }, username: { type: 'string' } }, required: ['id', 'username'] },
                        },
                        {
                            type: 'array',
                            items: { type: 'object', properties: { id: { type: 'null' }, username: { type: 'null' } }, required: ['id', 'username'] },
                            minItems: 1,
                            maxItems: 1,
                        },
                    ],
                },
                ldapgroupdn: { type: 'string' },
                msEntraIdGroupIds: { type: 'string' },
            },
            required: ['id', 'name', 'isshared', 'autogenerated', 'permissions', 'users', 'ldapgroupdn'],
            deprecated: true,
        },
        Permission: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
                operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                resource: { type: 'string' },
            },
            required: ['id', 'context', 'operation', 'resource'],
            deprecated: true,
        },
        'ReadonlyRecord<("id"|"context"|"operation"|"resource"|string),null>': {
            type: 'object',
            properties: { id: { type: 'null' }, context: { type: 'null' }, operation: { type: 'null' }, resource: { type: 'null' } },
            required: ['id', 'context', 'operation', 'resource'],
            additionalProperties: { type: 'null' },
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: { type: 'number' },
                nextPage: { type: 'number' },
                pageNumber: { type: 'number' },
                rowsPerPage: { type: 'number' },
                totalRows: { type: 'number' },
                totalRowsInPage: { type: 'number' },
            },
            required: ['totalPages', 'nextPage', 'pageNumber', 'rowsPerPage', 'totalRows', 'totalRowsInPage'],
            deprecated: true,
        },
    },
}
export const isMinimalPaginatedRoles = createValidator<MinimalPaginatedRoles>(MinimalPaginatedRolesSchema, 'isMinimalPaginatedRoles')
const MinimalPaginatedUsersSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPaginatedUsers',
    definitions: {
        MinimalPaginatedUsers: {
            type: 'object',
            properties: { users: { type: 'array', items: { $ref: '#/definitions/User' } }, pagination: { $ref: '#/definitions/Pagination' } },
            required: ['users', 'pagination'],
            deprecated: true,
        },
        User: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                autoGenerated: { type: 'boolean' },
                username: { type: 'string' },
                identityProvider: { type: 'string', enum: ['local', 'ldap', 'msentraid'] },
                grantTypes: { type: 'array', items: { $ref: '#/definitions/GrantType' } },
                tokens: {
                    type: 'array',
                    items: { $ref: '#/definitions/ReadonlyRecord%3C(%22fingerprint%22%7C%22created_at%22%7C%22expires_at%22)%2Cstring%3E' },
                },
                roles: { type: 'array', items: { $ref: '#/definitions/Role' } },
                mqttPublishPrefix: { type: ['string', 'null'] },
                mfa_is_enrolled: { type: 'boolean' },
                enforceMFAEnrollment: { type: 'boolean' },
            },
            required: [
                'id',
                'autoGenerated',
                'username',
                'identityProvider',
                'grantTypes',
                'tokens',
                'roles',
                'mqttPublishPrefix',
                'mfa_is_enrolled',
                'enforceMFAEnrollment',
            ],
            deprecated: true,
        },
        GrantType: {
            type: 'object',
            properties: { method: { $ref: '#/definitions/Method' }, isRequired: { type: 'boolean' } },
            required: ['method', 'isRequired'],
            deprecated: true,
        },
        Method: { type: 'string', enum: ['password', 'token', 'certificate'], deprecated: true },
        'ReadonlyRecord<("fingerprint"|"created_at"|"expires_at"),string>': {
            type: 'object',
            properties: { fingerprint: { type: 'string' }, created_at: { type: 'string' }, expires_at: { type: 'string' } },
            required: ['fingerprint', 'created_at', 'expires_at'],
        },
        Role: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                name: { type: 'string' },
                isShared: { type: 'boolean' },
                autoGenerated: { type: 'boolean' },
                ldapGroupDn: { type: 'string' },
                permissions: { type: 'array', items: { $ref: '#/definitions/Permission' } },
            },
            required: ['id', 'name', 'isShared', 'autoGenerated', 'permissions'],
            deprecated: true,
        },
        Permission: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
                operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                resource: { type: 'string' },
            },
            required: ['id', 'context', 'operation', 'resource'],
            deprecated: true,
        },
        Pagination: {
            type: 'object',
            properties: {
                totalPages: { type: 'number' },
                nextPage: { type: 'number' },
                pageNumber: { type: 'number' },
                rowsPerPage: { type: 'number' },
                totalRows: { type: 'number' },
                totalRowsInPage: { type: 'number' },
            },
            required: ['totalPages', 'nextPage', 'pageNumber', 'rowsPerPage', 'totalRows', 'totalRowsInPage'],
            deprecated: true,
        },
    },
}
export const isMinimalPaginatedUsers = createValidator<MinimalPaginatedUsers>(MinimalPaginatedUsersSchema, 'isMinimalPaginatedUsers')
const MinimalPermissionIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalPermissionIndex',
    definitions: {
        MinimalPermissionIndex: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    ids: { type: 'array', items: { type: 'string' } },
                    context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
                    operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                    resource: { type: 'string' },
                },
                required: ['context', 'ids', 'operation', 'resource'],
            },
            deprecated: true,
        },
    },
}
export const isMinimalPermissionIndex = createValidator<MinimalPermissionIndex>(MinimalPermissionIndexSchema, 'isMinimalPermissionIndex')
const MinimalRoleIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalRoleIndex',
    definitions: {
        MinimalRoleIndex: {
            type: 'array',
            items: { type: 'object', properties: { id: { type: 'string' }, name: { type: 'string' } }, required: ['id', 'name'] },
            deprecated: true,
        },
    },
}
export const isMinimalRoleIndex = createValidator<MinimalRoleIndex>(MinimalRoleIndexSchema, 'isMinimalRoleIndex')
const MinimalSessionResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalSessionResponse',
    definitions: {
        MinimalSessionResponse: {
            type: 'object',
            properties: {
                username: { type: 'string' },
                expiresAt: { type: 'string', description: 'ISO Format' },
                permissions: { type: 'array', items: { $ref: '#/definitions/Permission' } },
                mfa: { $ref: '#/definitions/ReadonlyRecord%3C(%22enabled%22%7C%22enforced%22)%2Cboolean%3E' },
            },
            required: ['username', 'expiresAt', 'permissions', 'mfa'],
            deprecated: true,
        },
        Permission: {
            type: 'object',
            properties: {
                id: { type: 'string' },
                context: { type: 'string', enum: ['control_plane', 'http', 'mqtt'] },
                operation: { type: 'string', enum: ['read', 'write', 'readWrite'] },
                resource: { type: 'string' },
            },
            required: ['id', 'context', 'operation', 'resource'],
            deprecated: true,
        },
        'ReadonlyRecord<("enabled"|"enforced"),boolean>': {
            type: 'object',
            properties: { enabled: { type: 'boolean' }, enforced: { type: 'boolean' } },
            required: ['enabled', 'enforced'],
        },
    },
}
export const isMinimalSessionResponse = createValidator<MinimalSessionResponse>(MinimalSessionResponseSchema, 'isMinimalSessionResponse')
const MinimalUserBannedResponseSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalUserBannedResponse',
    definitions: {
        MinimalUserBannedResponse: {
            type: 'object',
            properties: { error: { type: 'string', const: 'banned' }, minutesUntilBanEnd: { type: 'number' }, msg: { type: 'string' } },
            required: ['error', 'minutesUntilBanEnd', 'msg'],
            deprecated: true,
        },
    },
}
export const isMinimalUserBannedResponse = createValidator<MinimalUserBannedResponse>(MinimalUserBannedResponseSchema, 'isMinimalUserBannedResponse')
const MinimalUserIndexSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $ref: '#/definitions/MinimalUserIndex',
    definitions: {
        MinimalUserIndex: {
            type: 'array',
            items: { type: 'object', properties: { id: { type: 'string' }, username: { type: 'string' } }, required: ['id', 'username'] },
            deprecated: true,
        },
    },
}
export const isMinimalUserIndex = createValidator<MinimalUserIndex>(MinimalUserIndexSchema, 'isMinimalUserIndex')
